
import { useQuery } from '@tanstack/react-query';
import { COLOR_FILTERS, ColorFilterData } from '../data/color-filters';

/**
 * Hook to fetch color prompts from static data
 */
export const useStaticColorPrompts = () => {
  return useQuery({
    queryKey: ['static-color-prompts'],
    queryFn: async (): Promise<ColorFilterData[]> => {
      // Simulate async behavior to maintain interface compatibility
      await new Promise(resolve => setTimeout(resolve, 1));
      
      return COLOR_FILTERS.sort((a, b) => b.priority - a.priority);
    },
    staleTime: Infinity, // Static data never goes stale
    gcTime: Infinity, // Keep in cache forever
  });
};
